import axiosIns from "@/api/axios";

export const GET_LIST = (params) => {
    return axiosIns.get("/area-restriction");
};

export const CREATE = (payload) => {
    return axiosIns.post("/area-restriction", payload);
};

export const UPDATE = (args) => {
    return axiosIns.put(`/area-restriction/${args.id}`, args);
};

export const DELETE = (id) => {
    return axiosIns.delete(`/area-restriction/${id}`);
};